"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_INPUT_ITEM_TYPE = void 0;
exports.AUTH_INPUT_ITEM_TYPE = {
    synergyIdFree: 'synergyIdFree',
    mailAddressFree: 'mailAddressFree',
    textFree: 'textFree',
    numberFree: 'numberFree',
    dateFree: 'dateFree',
    monthDayFree: 'monthDayFree',
    passwordHashFree: 'passwordHashFree',
};
